import React from 'react';

import {
  Lottie,
} from '@uncinc/uncinc-react-kitchen-sink';

import dividerOne from '../../../assets/lotties/divider-1/data.json';
import dividerTwo from '../../../assets/lotties/divider-2/data.json';

import './style.scss';

const ParagraphDivider = ({ entity }) => {
  const dividerType = parseInt(entity.getIn(['field_divider_types', 0, 'entity', 'name', 0, 'value'], 1));
  return (
    <div className="ParagraphDivider">
      <Lottie
        className="ParagraphDivider"
        id={`ParagraphDivider-${Math.floor(Math.random() * (1000 - 2 + 1) + 2)}`}
        data={dividerType === 1 ? dividerOne : dividerTwo}
      />
    </div>
  );
};

export default ParagraphDivider;
